<template>
<v-row justify="center">
    <v-dialog v-model="dialog" ref="modal" @keydown.esc="clearFields()" persistent max-width="900px">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" outlined class="ma-2 white--text" color="primary">
                <v-icon left dark>mdi-plus</v-icon>
                Inserir Produto
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Cadastro de Produtos </span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-card-subtitle>
                Aqui você deverá cadastrar os seus produtos para o módulo <b>{{this.selCat}}</b>
                <v-divider></v-divider>
            </v-card-subtitle>
            <v-card-text>
                <v-row class="mt-0 mb-0 pt-0">
                    <v-col cols="4" sm="4">
                        <v-text-field v-model="nome" label="Nome do Produto *" required></v-text-field>
                    </v-col>
                    <v-col cols="8" sm="8">
                        <v-textarea v-model="descricao" rows="1" :auto-grow="true" label="Descrição"></v-textarea>
                    </v-col>  
                </v-row>
                <v-row class="mt-0 mb-0 pt-0">
                    <v-col cols="2" sm="2">
                        <v-text-field  v-model="tamanho" label="Tamanho"></v-text-field >
                    </v-col>    
                    <v-col cols="2" sm="2">
                        <v-text-field v-model="valor" label="Valor" value="10.00" prefix="R$" type="number" hint="Insira o valor do produto (#,##)" step="0.01"></v-text-field>
                    </v-col> 
                    <v-col cols="6" sm="6">
                        <v-file-input v-model="prodImg" small-chips multiple accept="image/*" label="Selecione Imagens para o seu Produto"></v-file-input>
                    </v-col>                         
                    <v-col cols="2" sm="2">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">                  
                                <v-switch v-on="on" flat v-model="ativo" :label="(ativo) ? 'Disponível' : 'Indisponível'"></v-switch>
                            </template>
                            <span>Selecione se o produto estiver disponível.</span>
                        </v-tooltip>  
                    </v-col>                             
                </v-row>
                <small>* Campos Obrigatórios</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="clearFields()">Fechar</v-btn>
                <v-btn color="blue darken-1" :loading="loading" text @click="addProducts()">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-row>
</template>

<script>
import {
    db, files
} from '@/main'
import dbFunctions from "@/dbFunctions"
import store from "@/store"
export default {
    name: 'createProd',
    props:['selCatId','selCat'],
    data: () => ({
        dialog: false,
        loading: false,
        rules: {
            required: value => !!value || 'Campo Obrigatório.',
            min: v => v.length >= 8 || 'Min 8 characters',
            emailMatch: () => ('The email and password you entered don\'t match'),
        },
        nome: "",
        ativo: true,
        valor: '',
        tamanho: '',
        descricao: '',
        status:true,
        key: 0,
        prodImg: []
    }),
    methods: {   
        addProducts() {
            this.getDataInfo = dbFunctions.getDataInfo
            this.loading = true
            let ref = files.ref();
            let imagens = []
            
            this.prodImg.filter((img) => {
                imagens.push(this.$store.getters.company.data.id+'/images/'+img.name)
                let mountainImagesRef = ref.child(this.$store.getters.company.data.id+'/images/'+img.name);
                mountainImagesRef.put(img).then(function() {
                    console.log('Uploaded a blob or file!');
                });                
            })

            const produto = {
                nome: this.nome,
                empresa: db.collection("empresas").doc(this.$store.getters.company.data.id),
                ativo: this.status,
                createAt: new Date(),
                categoria: db.collection("categorias").doc(this.selCatId),
                descricao: this.descricao,
                tamanho: this.tamanho,
                preco: this.valor,
            }

            if (imagens.length > 0)
                produto.imagens = imagens    

            console.log("produto", produto, ref)

            db.collection('produtos').add(produto).then(async() => {
                this.loading = false
                let success = {
                    'active':true,
                    'color':'success',
                    'message':'Produto Salvo com Sucesso'
                }                
                await this.reloadData(this.$store.getters.company.data.id)
                this.$emit("loadMessage",success)
                this.$emit("productAdded")

                this.clearFields()
            }).catch(function (error) {
                let errorMessage = {
                    'active':true,
                    'color':'error',
                    'message': error
                }          
                console.error('Error to Create Product: ' + error)
                this.$emit("loadMessage",errorMessage)
            })
        },
        clearFields(){
            this.nome = ''
            this.status = true
            this.descricao = ''
            this.tamanho = ''
            this.valor = ''
            this.dialog = false
        }, 
        async reloadData(companyId){
            let dataStore = await this.getDataInfo(companyId)
            store.dispatch("fetchData",dataStore)
            // console.log("reloadData", dataStore)
        },               
        Save(){
            console.log(this.prodImg)
        }
    },
}
</script>
